import script from "./CardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CardComponent.vue?vue&type=style&index=0&id=56575304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56575304"]])

export default __exports__